import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import { DeclarativeMapLayerComponent } from '@cue/map/elements';
import { NAVIGATION_SETTINGS } from '@cue/navigation-settings';

@Component({
  selector: 'cue-map-area',
  imports: [DeclarativeMapLayerComponent],
  templateUrl: './map-area.component.html',
  styleUrl: './map-area.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapAreaComponent {
  navigationSettings = inject(NAVIGATION_SETTINGS);
  click = output();

  focused = input<boolean, boolean | 'true' | 'false'>(false, {
    transform: booleanAttribute,
  });
  geoJson = input<any>();
  radius = input<number>(10);
  childAreaId = input<number>();

  color = input<string>('rgba(206,214,222,0.5)');

  fillColor = computed(() => {
    return this.navigationSettings.design.background.area;
  });

  fillOpacity = computed(() => {
    return this.focused() ? 0.6 : 0.2;
  });

  layerComp = viewChild(DeclarativeMapLayerComponent);

  focus() {
    this.layerComp()?.focus();
  }
}
